import { render, staticRenderFns } from "./VCardContent.vue?vue&type=template&id=f08e10b4&scoped=true&"
import script from "./VCardContent.vue?vue&type=script&lang=js&"
export * from "./VCardContent.vue?vue&type=script&lang=js&"
import style0 from "./VCardContent.vue?vue&type=style&index=0&id=f08e10b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08e10b4",
  null
  
)

export default component.exports